<template>
    <div>
        <ul>
            <li v-for="laptop in laptops" :key="laptop.id">https://ultrashop.uz/{{laptop.brand.slug + '/' + laptop.slug + '/' + laptop.id}}</li>
        </ul>
    </div>
</template>

<script>

    import axios from 'axios'
    import {API_URL} from "../../main";


    export default {
        name: 'sitemap',
        inject: ['openLoading', 'closeLoading'],
        data() {
            return {
                laptops: [],
                paging: {
                    count: Number,
                    limit: 1000,
                    offset: 0
                },
                ordering: '-created',
                available_stock: -10,
            }
        },
        methods: {
            fetchLaptops() {
                this.openLoading()
                axios.get(API_URL + '/laptops', {
                    params: {
                        ordering: this.ordering,
                        offset: this.paging.offset,
                        quantity: this.available_stock,
                        limit: this.paging.limit
                    }
                })
                    .then(response => {
                        this.closeLoading();
                        this.paging.count = response.data.count;
                        this.laptops = this.laptops.concat(response.data.results);
                    })
            },
        },
        created() {
            this.fetchLaptops()
        }
    }
</script>